import { Component, inject, input, LOCALE_ID, NgModule, OnInit, output, signal } from '@angular/core';
import { ProductFiltersApi } from '../../../../pages/admin-dashboard/products/product.model';
import { FormsModule, NgModel } from '@angular/forms';
import { NgStyle } from '@angular/common';
import { LookupVTO } from '../../../../pages/admin-dashboard/admin-companies/admin-companies.model';
import { SubcategoryResultSet } from '../../../../pages/admin-dashboard/categories/category.model';
import { CategoryService } from '../../../../services/category/category.service';

@Component({
  selector: 'app-admin-products-list-filter',
  standalone: true,
  imports: [FormsModule],
  templateUrl: './admin-products-list-filter.html',
  styleUrl: './admin-products-list-filter.scss',
})
export class AdminProductsListFilter {
  private locale = inject(LOCALE_ID);
  hasSubProducts = signal<boolean | ''>('');
  dateRangeError = signal(false);
  filters = input.required<ProductFiltersApi>();
  showProductTitleDropdown = input.required<boolean>();
  productTitleLoading = input.required<boolean>();
  productTitleResults = input.required<{ id: number; titleAr: string; titleEn: string }[]>();
  mfgCompanies = input.required<LookupVTO[]>();
  categories = input.required<LookupVTO[]>();
  subCategories = input.required<SubcategoryResultSet | undefined>();
  // sliderTrackStyle = input.required<string>();
  onProductTitleChange = output<string>();

  productTitleFocus = output<void>();

  selectProductTitle = output<{ id: number; titleAr: string; titleEn: string }>();
  onCategoryChange = output<number | undefined>();

  // getSliderTrackStyle = output<{ from: number; to: number }>();
  toggleSortOrder = output();
  resetFilters = output();
  applyFilters = output();
  hasSubProductsChange = output<boolean | ''>();

  validateDateRange(): void {
    const from = this.filters().createdOnFrom;
    const to = this.filters().createdOnTo;

    if (from && to) {
      this.dateRangeError.set(new Date(to) < new Date(from));
    } else {
      this.dateRangeError.set(false);
    }
  }

  onChangeTitle(value: string) {
    this.onProductTitleChange.emit(value);
  }
  onSelectProductTitle(item: { id: number; titleAr: string; titleEn: string }) {
    this.selectProductTitle.emit(item);
  }
  onCategoryChangeFn(categoryId: number | undefined) {
    this.onCategoryChange.emit(categoryId);
  }

  onHasSubProductsChange(value: string) {
    const mapped = value === '' ? '' : value === 'true';

    this.hasSubProducts.set(mapped);
    this.hasSubProductsChange.emit(mapped);
  }

  onProductTitleFocus() {
    this.productTitleFocus.emit();
  }
  onToggleSortOrder() {
    this.toggleSortOrder.emit();
  }
  onResetFilters() {
    this.resetFilters.emit();
  }
  onApplyFilters() {
    if (this.dateRangeError()) return;
    this.applyFilters.emit();
  }

  isArabic() {
    return this.locale.startsWith('ar');
  }
  isEnglish() {
    return this.locale.startsWith('en');
  }
}
